import React, { useEffect, useState } from 'react';
import { Box, Button, Modal, Typography } from '@mui/material';
import styles from 'assets/styles/modal.module.scss';
import { addModalStyle } from 'components/InitialStyle';
import { useForm } from 'react-hook-form';
import Loading from 'components/loading';
import { toast } from 'react-toastify';
import { useMutation, useQuery } from 'react-query';
import LoadingButton from 'components/loadingButton';
import PasswordGenerator from 'components/passwordGenerator';
import userService from 'services/user';
import { AiOutlineCheck } from 'react-icons/ai';
import { shallowEqual, useSelector } from 'react-redux';
import EmailInput from 'components/emailInput';

export default function UserEdit({ open, handleCancel }) {
  const {
    control,
    reset,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm();

  const [password, setPassword] = useState('');
  const [show, setShow] = useState(false);
  const { user } = useSelector((state) => state.auth, shallowEqual);
  const passwordValue = watch('password');

  const { isLoading: loading } = useQuery(
    [['user_getByID', user.userId]],
    () => userService.getID(user.userId),
    {
      onSuccess: (res) => {
        setValue('login', res?.data?.login);
        setValue('description', res?.data?.description);
      },
      onError: (err) => {
        console.log('error user_getByID', err);
        toast.error(err?.data?.detail?.detail);
      },
      enabled: Boolean(user.userId),
    }
  );

  const { mutate: edit, isLoading: editLoading } = useMutation({
    mutationFn: (data) => userService.update(user.userId, data),
    onSuccess: () => {
      toast.success('Пользователь успешно изменен');
      handleCancel();
    },
    onError: (error) => {
      console.log('error user_update', error);
      toast.error(error?.data?.detail?.detail);
    },
  });

  const formSubmit = (data) => {
    const params = {
      login: data.login,
      password: open.id ? (show ? password : undefined) : password,
    };
    edit(params);
  };

  useEffect(() => {
    setPassword(passwordValue);
  }, [passwordValue]);

  return (
    <div>
      <Modal
        className={styles.modal}
        open={Boolean(open)}
        onClose={handleCancel}
      >
        <Box sx={{ ...addModalStyle, width: '500px' }}>
          {loading ? (
            <Loading />
          ) : (
            <form onSubmit={handleSubmit(formSubmit)}>
              <div className={styles.titleCont}>
                <Typography
                  className={styles.title}
                  variant='h3'
                  align='center'
                >
                  Изменить пользователя
                </Typography>
              </div>

              <Box className={styles.content}>
                <Box sx={{ mb: '15px', mt: '15px' }}>
                  <EmailInput
                    error={errors}
                    name='login'
                    control={control}
                    label={'Логин:'}
                  />
                </Box>

                <PasswordGenerator
                  control={control}
                  error={errors}
                  password={password}
                  name='password'
                  label={'Пароль:'}
                  show={open.id ? show : true}
                  setShow={setShow}
                  type={open.id ? 'edit' : ''}
                />
              </Box>

              <Box className={styles.modalFooter}>
                <Button
                  className={styles.cancel}
                  onClick={() => {
                    handleCancel();
                    reset();
                  }}
                >
                  Отменить
                </Button>
                <LoadingButton
                  type='submit'
                  loading={editLoading}
                  className={styles.send}
                  startIcon={<AiOutlineCheck className={styles.sendIcon} />}
                >
                  Подтвердить
                </LoadingButton>
              </Box>
            </form>
          )}
        </Box>
      </Modal>
    </div>
  );
}
